import './onView.css';
import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import { Container, Button, Card, CardContent } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import { ViewPage } from './ViewPage';
import ViewComments from './viewComments';
import { Tab, Box } from '@mui/material'
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Typography, Fab } from '@mui/material';
import { PROD } from '../../../common/constants';
import { PrintIcon } from '../../../common/icons';

function OnView(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const componentRef = useRef(null);
  const print = useReactToPrint({
    content: () => componentRef.current,
  })
  const [tabValue, setTabValue] = React.useState('1');
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG49</p>}
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Typography variant="h4" sx={{ m: 1 }}>
                <Fab size="small" aria-label="back" title='Back' onClick={() => (navigate(-1))}>
                  <KeyboardArrowLeftRounded />
                </Fab>
              </Typography>
              <Tab label="View Comments" value="1" />
              <Tab label="View Details" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <ViewComments registrationCompleted={location?.state?.data?.registrationCompleted}></ViewComments>
          </TabPanel>
          <TabPanel value="2">
            <Card>
              <CardContent>
                <ViewPage ref={componentRef} isPreview="true" isScrutinyView={location?.state?.data?.isScrutinyView} bambooSpeciesRes={props.bambooSpeciesRes}></ViewPage>
              </CardContent>
            </Card>
            <Box hidden={tabValue === "1"} display='flex' alignItems="center" mt={2} justifyContent="center" style={{ float: "right" }} >
              <Button startIcon={<PrintIcon/>} sx={{ minWidth: 100 }} variant='contained' onClick={print}>Print</Button>
            </Box>
          </TabPanel>
        </TabContext>
      </Container>
    </>
  );

}

export default OnView;
